import { useMemo } from 'react';

import { usePrivateWorkspaceAgentGuidedVariantClipSubjects } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantClipSubjects';
import {
  getWorkspaceAgentGuidedVariantMediaSelection,
  type WorkspaceAgentGuidedVariantMediaSelection,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentGuidedVariantSkipCounts';

export const usePrivateWorkspaceAgentGuidedVariantMediaSelection = (): WorkspaceAgentGuidedVariantMediaSelection => {
  const { clipSubjects } = usePrivateWorkspaceAgentGuidedVariantClipSubjects();

  return useMemo(
    () => getWorkspaceAgentGuidedVariantMediaSelection(clipSubjects.map(({ ext, type }) => ({ ext, type }))),
    [clipSubjects],
  );
};
